import { render, staticRenderFns } from "./OrdersItemDetails.vue?vue&type=template&id=d4a0a4da&"
import script from "./OrdersItemDetails.vue?vue&type=script&lang=ts&"
export * from "./OrdersItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersItemDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VDivider,VIcon,VList,VListItem,VListItemContent})
